export enum JobStatus {
  PROCESSING = "processing",
  FAILED = "failed",
  COMPLETED = "completed",
  PARTIAL_SUCCESS = "partial_success",
}
